import { MouseEvent, ReactNode, useEffect, useState } from 'react';
import { Icon, Text, useToast } from '@pairy/pds-react';
import cn from 'classnames';
import { atom, useAtomValue, useSetAtom } from 'jotai';

import ProPlanUpgradeModal from '@/components/User/_components/common/ProPlanUpgradeModal';
import { UserInfo } from '@/types/user';
import { notSetCtaFormFileIdListAtom } from '@/state/file/uploadingfile.atom';

import * as Styled from '../index.styles';

import EditFileModal from './EditFileModal';

interface Props {
  fileId: number;
  fileName: string;
  fileThumbnail: string;
  userPlan: UserInfo['subscriptionPlan']['name'];
  isDisabled: boolean;
  handleDisabledButtonClick: (e: MouseEvent<HTMLButtonElement>) => void;
  handleHoverSideAction?: (open: boolean) => void;
  children?: ReactNode;
}

export const openEditModalIdAtom = atom<number | null>(null);

const EditButton = ({
  fileId,
  fileName,
  fileThumbnail,
  userPlan,
  isDisabled,
  handleDisabledButtonClick,
  handleHoverSideAction,
  children,
}: Props) => {
  const toast = useToast();
  const notSetCtaFormFileIdList = useAtomValue(notSetCtaFormFileIdListAtom);
  const setOpenEditModalId = useSetAtom(openEditModalIdAtom);

  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [isOpenProPlanUpgradeModal, setIsOpenProPlanUpgradeModal] =
    useState(false);

  const handleClickEditButton = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isDisabled) {
      handleDisabledButtonClick(e);
      return;
    }
    if (handleHoverSideAction) {
      handleHoverSideAction(false);
    }

    setOpenEditModalId(fileId);

    if (userPlan === 'Free') {
      toast('해당 기능은 Basic 플랜부터 이용할 수 있습니다');
      setIsOpenProPlanUpgradeModal(true);
    } else {
      setIsOpenEditModal(true);
    }
  };

  useEffect(() => {
    if (!isOpenEditModal) {
      setOpenEditModalId(null);
    }
  }, [isOpenEditModal, setOpenEditModalId]);

  const isCtaFormSettingModalOpen = notSetCtaFormFileIdList.length > 0;

  return (
    <>
      {children ? (
        <button
          className={cn('', {
            'is-disabled': isDisabled,
          })}
          onClick={handleClickEditButton}
        >
          {children}
        </button>
      ) : (
        <Styled.GrayBorderButton
          className={cn('', {
            'is-disabled': isDisabled,
          })}
          onClick={handleClickEditButton}
        >
          <Icon icon="ph:note-pencil" size={17} color="inherit" />
          <Text variant="sm-medium" color="inherit">
            수정
          </Text>
        </Styled.GrayBorderButton>
      )}
      {!isCtaFormSettingModalOpen && (
        <EditFileModal
          isOpen={isOpenEditModal}
          setIsOpen={setIsOpenEditModal}
          fileId={fileId}
          fileName={fileName}
          fileThumbnail={fileThumbnail}
        />
      )}
      {!isCtaFormSettingModalOpen && isOpenProPlanUpgradeModal && (
        <ProPlanUpgradeModal
          onOpenChange={(open) => {
            setIsOpenProPlanUpgradeModal(open);
          }}
        />
      )}
    </>
  );
};

export default EditButton;
